import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../../action-button';

const PublishButton = ({ label, onClick, isCompact }) => {
  const iconProps = isCompact
    ? {
        iconGlyph: 'publish',
        iconPlacement: 'after',
      }
    : {};

  return (
    <ActionButton
      appearance="accent"
      format="solid"
      label={isCompact ? null : label}
      onClick={onClick}
      size="small"
      {...iconProps}
    />
  );
};

PublishButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isCompact: PropTypes.bool.isRequired,
};

export default PublishButton;
